import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import { FormattedMessage, injectIntl } from 'react-intl'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import PaymentComparisonComponent from '../../PaymentComparison'

import { LOCALE_PREFIX } from './constants'

@hocBlock(config.modules.report.key)
@injectIntl
export default class PaymentComparison extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        module: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true

        return false
    }

    render() {
        const {
            module,
            block,
            data,
            id,
            intl: { formatMessage },
            transformedData,
        } = this.props

        return (
            <div className={cx('block-payment-comparison')}>
                <PaymentComparisonComponent
                    data={transformedData?.summary?.summary}
                    chartData={transformedData?.chartData}
                    legend={transformedData?.summary?.legend}
                    originalData={data}
                    module={module}
                    block={block}
                    id={id}
                    translates={{
                        p12label: <FormattedMessage id={`${LOCALE_PREFIX}.p12label`} values={{ br: <br /> }} />,
                        p12sectorLabel: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.p12sectorLabel`} values={{ br: <br /> }} />
                        ),
                        dueLabel: <FormattedMessage id={`${LOCALE_PREFIX}.dueLabel`} values={{ br: <br /> }} />,
                        description: formatMessage({ id: `${LOCALE_PREFIX}.description` }),
                        interval: formatMessage({ id: `${LOCALE_PREFIX}.interval` }),
                        p12sectorText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.p12sectorText`} values={{ br: <br /> }} />
                        ),
                        selfColumnText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.selfColumnText`} values={{ br: <br /> }} />
                        ),
                        suppliersColumnText: formatMessage({ id: `${LOCALE_PREFIX}.suppliersColumnText` }),
                        clubColumnText: formatMessage({ id: `${LOCALE_PREFIX}.clubColumnText` }),
                        noData: <FormattedMessage id={`${LOCALE_PREFIX}.noData`} />,
                    }}
                />
            </div>
        )
    }
}
